export const getMarketNameNFL = (getTranslation: (key: string, defaultText: string) => string): [string, string, string] => {
    return [
        getTranslation('market.nfl.moneyline', 'Money Line'),
        getTranslation('market.nfl.spread', 'Spread'),
        getTranslation('market.nfl.total', 'Total')
    ];
};
